import { render, staticRenderFns } from "./cBotoom.vue?vue&type=template&id=105ce117&scoped=true"
import script from "./cBotoom.vue?vue&type=script&lang=js"
export * from "./cBotoom.vue?vue&type=script&lang=js"
import style0 from "./cBotoom.vue?vue&type=style&index=0&id=105ce117&prod&style=true&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105ce117",
  null
  
)

export default component.exports